var map = {
	"./BasisGrotesquePro-Light.ttf": 705,
	"./BasisGrotesquePro-Regular.ttf": 707,
	"./CaslonGraD.ttf": 709,
	"./CircularPro-Black.ttf": 712,
	"./CircularPro-BlackItalic.ttf": 715,
	"./CircularPro-Bold.ttf": 718,
	"./CircularPro-BoldItalic.ttf": 721,
	"./CircularPro-Book.ttf": 724,
	"./CircularPro-BookItalic.ttf": 727,
	"./CircularPro-Medium.ttf": 730,
	"./CircularPro-MediumItalic.ttf": 733
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1187;



//////////////////
// WEBPACK FOOTER
// ./public/fonts ^\.\/.*\.ttf$
// module id = 1187
// module chunks = 168707334958949